<template>
  <div class="flex-column">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <b-form-group label="Test House" class="mr-2">
          <b-form-input v-model="filters.companyName"  @input="onSearch" size="sm" />
        </b-form-group>
        <b-form-group label="Sales Order #" class="mr-2">
          <b-form-input v-model="filters.soNumber"  @input="onSearch" size="sm" />
        </b-form-group>
        <b-form-group label="Purchase Order #" class="mr-2">
          <b-form-input v-model="filters.pONumber"  @input="onSearch" size="sm" />
        </b-form-group>
        <b-form-group label="Work Order #" class="mr-2">
          <b-form-input v-model="filters.wONumber"  @input="onSearch" size="sm" />
        </b-form-group>
        <b-form-group label="Part #" class="mr-2">
          <b-form-input v-model="filters.partNumber"  @input="onSearch" size="sm" />
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
  import { debounce } from 'lodash';
  import { DATE_FORMAT } from '@/shared/constants';

  const SEARCH_DEBOUNCE_TIME = 750;

  export default {
    components: {
    },
    props: {
      filters: {
        type: Object,
        default: () => {}
      },
      keyNdx: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
      }
    },
    methods: {
      onSearch: debounce(function () {
        this.$emit('onSearch', this.keyNdx);
      }, SEARCH_DEBOUNCE_TIME),
    }
  }
</script>